import React from 'react';
import { Box, Typography } from '@mui/material';
import { IDropdownOption } from '../../../../../types/commonTypes';
import { EventTypeFilterEnum } from '../../../../../constants/enums';
import palette from '../../../../../theme/palette';
import typography from '../../../../../theme/typography';
import DropdownV2 from '../../../../reusable-components/dropdown-v2/DropdownV2';
import './filterField.scss';

interface EventTypeFilterFieldProps {
  value: string;
  onChange: (value: string) => void;
}

const EventTypeFilterField: React.FC<EventTypeFilterFieldProps> = ({ value, onChange }) => {
  const eventTypeOptions: IDropdownOption[] = [
    { id: EventTypeFilterEnum.B2C, value: 'B2C' },
    { id: EventTypeFilterEnum.B2B, value: 'B2B' },
    { id: EventTypeFilterEnum.Prepaid, value: 'Prepaid' },
  ];

  return (
    <Box className="filterField">
      <Typography className="filterFieldLabel">Event type</Typography>
      <Box className="filterFieldInput">
        <DropdownV2
          value={value || ''}
          options={eventTypeOptions}
          onChange={onChange}
          placeholder="Select"
          className="filterDropdown"
          renderValue={(selected) => {
            if (selected.length === 0) {
              return (
                <p
                  style={{
                    color: palette.grey['600'],
                    margin: 0,
                    fontFamily: typography.fontPrimaryGeneralSans,
                    fontWeight: typography.fontWeightRegular,
                  }}
                >
                  Select
                </p>
              );
            }
            return selected;
          }}
          selectProps={{
            displayEmpty: true,
          }}
        />
      </Box>
    </Box>
  );
};

export default EventTypeFilterField;
